/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import has from "../../core/has.js";
var n;
function r(r, t, o = {}) {
  const e = t === n.WEBGL1 ? "webgl" : "webgl2",
    c = r.getContext(e, o);
  return c || null;
}
function t(n, t, e = {}) {
  const c = o(n);
  for (const o of c) {
    const n = r(t, o, e);
    if (n) return n;
  }
  return null;
}
function o(r) {
  if ("3d" === r) return [n.WEBGL2];
  const t = has("esri-force-webgl");
  return t === n.WEBGL1 || t === n.WEBGL2 ? [t] : has("mac") && has("chrome") ? [n.WEBGL1, n.WEBGL2] : [n.WEBGL2, n.WEBGL1];
}
!function (n) {
  n[n.WEBGL1 = 1] = "WEBGL1", n[n.WEBGL2 = 2] = "WEBGL2";
}(n || (n = {}));
export { n as ContextType, r as createContext, t as createContextForView, o as getContextTypes };